import axiosInstance from "@/services/api/instance";
import store from "@/store";

export default {
    get(tagOff) {
        return axiosInstance.get(`/space/${store.getters["global/getSpace"]}/tag/items/`, {
            params: tagOff ? { tag_off: tagOff } : {}
        });
    },
    add(tag) {
        return axiosInstance.post(`/space/${store.getters["global/getSpace"]}/tag/add/`, {
            name: tag
        });
    }
}